import config from './config';
//#endregion
//#region Functions
// oauth2-api
// 1.0
// http://test5-bg-api-gateway.zhiketong.net[80]/oauth2-api/swagger-ui.html
/**
 * getTableauViews
 * @param header The http request header parameters.
 */
export function getAdminTableauTableauViewList(header) {
    var url = "/oauth2-api/admin/tableau/tableau_view_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * test
 * @param header The http request header parameters.
 */
export function getAdminTableauTest(header) {
    var url = "/oauth2-api/admin/tableau/test";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * test1
 * @param header The http request header parameters.
 */
export function getAdminTableauTest1(header) {
    var url = "/oauth2-api/admin/tableau/test1";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * getTicketAndReturnUrl
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getAdminTableauTicketUrl(query, header) {
    var url = "/oauth2-api/admin/tableau/ticket_url";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据accessToken获取用户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCUserUserInfoByAccessToken(query, header) {
    var url = "/oauth2-api/c/user/user_info_by_accessToken";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据手机号获取短信验证码
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbLoginGetCaptcha(query, header) {
    var url = "/oauth2-api/eb/login/get_captcha";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过图形验证码获取短信验证码（含图形验证码校验）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLoginGetCaptchaWithImageCaptcha(body, header) {
    var url = "/oauth2-api/eb/login/get_captcha_with_image_captcha";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据手机号获取图形验证码
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbLoginGetImageCaptcha(query, header) {
    var url = "/oauth2-api/eb/login/get_image_captcha";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取特殊酒店认证配置信息
 * @param header The http request header parameters.
 */
export function getEbLoginGetSpecialAuthConfig(header) {
    var url = "/oauth2-api/eb/login/get_special_auth_config";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据手机号和验证码登录post
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLoginLoginWithCaptchaPost(body, header) {
    var url = "/oauth2-api/eb/login/login_with_captcha_post";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 生成句子链接
 * @param header The http request header parameters.
 */
export function getEbLoginSsoGenJuziUrl(header) {
    var url = "/oauth2-api/eb/login/sso/gen_juzi_url";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 验证码校验
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLoginVerifyCaptcha(body, header) {
    var url = "/oauth2-api/eb/login/verify_captcha";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 图形验证码校验
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLoginVerifyImageCaptcha(body, header) {
    var url = "/oauth2-api/eb/login/verify_image_captcha";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据账号密码(加密)登录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLoginWithEncryptPassword(body, header) {
    var url = "/oauth2-api/eb/login/with_encrypt_password";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据账号密码登录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLoginWithPassword(body, header) {
    var url = "/oauth2-api/eb/login/with_password";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取登录白名单列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLoginWhiteIpGetLoginWhiteIpList(body, header) {
    var url = "/oauth2-api/eb/login_white_ip/get_login_white_ip_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存登录白名单接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLoginWhiteIpSaveLoginWhiteIp(body, header) {
    var url = "/oauth2-api/eb/login_white_ip/save_login_white_ip";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量为员工创建代理公司
 * @param header The http request header parameters.
 */
export function postEbManagerBatchCreateAgentDepartment(header) {
    var url = "/oauth2-api/eb/manager/batch_create_agent_department";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 批量删除员工关系（集团范围内）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbManagerBatchDeleteUserHotel(body, header) {
    var url = "/oauth2-api/eb/manager/batch_delete_user_hotel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据酒店ids批量获取部门信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbManagerBatchDepartmentsByHotelIds(body, header) {
    var url = "/oauth2-api/eb/manager/batch_departments_by_hotel_ids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 变更员工与酒店关系（最终只保留一条user_hotel记录）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbManagerChangeUserHotelRelation(body, header) {
    var url = "/oauth2-api/eb/manager/change_user_hotel_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除部门
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerDeleteDepartment(query, header) {
    var url = "/oauth2-api/eb/manager/delete_department";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除角色
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerDeleteRole(query, header) {
    var url = "/oauth2-api/eb/manager/delete_role";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取指定酒店部门和权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerDepartment(query, header) {
    var url = "/oauth2-api/eb/manager/department";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取部门类别
 * @param header The http request header parameters.
 */
export function getEbManagerDepartmentCategory(header) {
    var url = "/oauth2-api/eb/manager/department_category";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取所有酒店部门和权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerDepartments(query, header) {
    var url = "/oauth2-api/eb/manager/departments";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店部门列表(分页)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerDepartmentsList(query, header) {
    var url = "/oauth2-api/eb/manager/departments_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有酒店部门(包括代理公司)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerGetAllHotelDepartments(query, header) {
    var url = "/oauth2-api/eb/manager/get_all_hotel_departments";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店id获取所有酒店部门和权限
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbManagerGetDepartmentsByHotelId(body, header) {
    var url = "/oauth2-api/eb/manager/get_departments_by_hotel_id";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取集团商户中重复员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerGetDuplicateUserListByBrand(query, header) {
    var url = "/oauth2-api/eb/manager/get_duplicate_user_list_by_brand";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有职位和角色信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerGetJobRoleList(query, header) {
    var url = "/oauth2-api/eb/manager/get_job_role_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户角色信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerGetRoleInfo(query, header) {
    var url = "/oauth2-api/eb/manager/get_role_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户角色列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerGetRoleList(query, header) {
    var url = "/oauth2-api/eb/manager/get_role_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取集团商户员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerGetUserListByBrand(query, header) {
    var url = "/oauth2-api/eb/manager/get_user_list_by_brand";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有可配置的权限列表树
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerPermissionTree(query, header) {
    var url = "/oauth2-api/eb/manager/permission_tree";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存部门
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbManagerSaveDepartment(query, body, header) {
    var url = "/oauth2-api/eb/manager/save_department";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 保存角色
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbManagerSaveRole(query, body, header) {
    var url = "/oauth2-api/eb/manager/save_role";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 保存员工
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbManagerSaveUser(query, body, header) {
    var url = "/oauth2-api/eb/manager/save_user";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 获取员工
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbManagerUser(query, header) {
    var url = "/oauth2-api/eb/manager/user";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取指定类型的菜单列表集合
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postEbMenuGetEbMenus(body, header) {
    var url = "/oauth2-api/eb/menu/get_eb_menus";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据登录人获取指定类型的菜单列表集合
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbMenuGetMenusByUser(query, header) {
    var url = "/oauth2-api/eb/menu/get_menus_by_user";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户授权配置信息
 * @param header The http request header parameters.
 */
export function getEbOauthGetMerchantOauthConfig(header) {
    var url = "/oauth2-api/eb/oauth/get_merchant_oauth_config";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取员工认证配置
 * @param header The http request header parameters.
 */
export function getEbOauthGetUserLoginNotIdentifyConfig(header) {
    var url = "/oauth2-api/eb/oauth/get_user_login_not_identify_config";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 保存商户授权配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbOauthSaveMerchantOauthConfig(body, header) {
    var url = "/oauth2-api/eb/oauth/save_merchant_oauth_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存员工认证配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbOauthSaveUserIdentifyConfig(body, header) {
    var url = "/oauth2-api/eb/oauth/save_user_identify_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取默认选择的权限集合
 * @param header The http request header parameters.
 */
export function getEbPermissionGetDefaultSelectPermissions(header) {
    var url = "/oauth2-api/eb/permission/get_default_select_permissions";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取酒店员工(非zkt)拥有指定权限的酒店列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function getEbPermissionGetHotelsByUserPermission(query, header) {
    var url = "/oauth2-api/eb/permission/get_hotels_by_user_permission";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取员工在所有商户下的权限(不去重)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function getEbPermissionGetUserAllPermissions(query, header) {
    var url = "/oauth2-api/eb/permission/get_user_all_permissions";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取指定商户员工角色权限信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbPermissionGetUserHotelRolePermissions(query, header) {
    var url = "/oauth2-api/eb/permission/get_user_hotel_role_permissions";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据url path 获取指定接口所需权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbPermissionInterfacePermission(query, header) {
    var url = "/oauth2-api/eb/permission/interface_permission";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 判断指定员工在指定酒店是否存在指定操作权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbPermissionIsHasPermission(query, header) {
    var url = "/oauth2-api/eb/permission/is_has_permission";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId,userId，得到用户权限列表（去重）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbPermissionUserPermissions(query, header) {
    var url = "/oauth2-api/eb/permission/user_permissions";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId,Auth中userId，得到用户权限列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbPermissionUserPermissionsByAuthuser(query, header) {
    var url = "/oauth2-api/eb/permission/user_permissions_by_authuser";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据角色模板id获取角色模板信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbRoleGetTemplateRoleInfo(query, header) {
    var url = "/oauth2-api/eb/role/get_template_role_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取角色模板列表
 * @param header The http request header parameters.
 */
export function getEbRoleGetTemplateRoleList(header) {
    var url = "/oauth2-api/eb/role/get_template_role_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * url签名
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbSignSignUrl(body, header) {
    var url = "/oauth2-api/eb/sign/sign_url";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * url验签
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbSignVerifySignedUrl(body, header) {
    var url = "/oauth2-api/eb/sign/verify_signed_url";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 添加登录登出日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserAddLoginLogoutInfo(body, header) {
    var url = "/oauth2-api/eb/user/add_login_logout_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据accessToken获取用户基本信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserBaseUserInfo(query, header) {
    var url = "/oauth2-api/eb/user/base_user_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量删除员工
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserBatchDeleteUser(body, header) {
    var url = "/oauth2-api/eb/user/batch_delete_user";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过excel批量导入员集团门店工信息(文件流)
 * @param header The http request header parameters.
 */
export function postEbUserBatchImportBrandUser(header) {
    var url = "/oauth2-api/eb/user/batch_import_brand_user";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 通过excel批量导入员工信息(文件流)
 * @param header The http request header parameters.
 */
export function postEbUserBatchImportUser(header) {
    var url = "/oauth2-api/eb/user/batch_import_user";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 批量导入员工信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postEbUserBatchImportUserInfo(body, header) {
    var url = "/oauth2-api/eb/user/batch_import_user_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量同步员工到其他酒店
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserBatchSynchronousUsersToHotels(body, header) {
    var url = "/oauth2-api/eb/user/batch_synchronous_users_to_hotels";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量修改员工部门、职位、角色信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserBatchUpdateUserDepartment(body, header) {
    var url = "/oauth2-api/eb/user/batch_update_user_department";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量获取员工信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserBatchUserHotelInfos(body, header) {
    var url = "/oauth2-api/eb/user/batch_user_hotel_infos";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 切换酒店
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserChangeUserCurrentHotelPost(body, header) {
    var url = "/oauth2-api/eb/user/changeUserCurrentHotelPost";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 切换酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserChangeUserCurrentHotel(query, header) {
    var url = "/oauth2-api/eb/user/change_user_current_hotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据用户id查询其在每个酒店的部门中是否是历史任职部门
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserCheckUserInDemissionDepartmentByUserId(query, header) {
    var url = "/oauth2-api/eb/user/check_user_in_demission_department_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 校验员工是否有访问页面path权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserCheckUserPathPermission(query, header) {
    var url = "/oauth2-api/eb/user/check_user_path_permission";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除下载员工缓存
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserDeleteRedis(query, header) {
    var url = "/oauth2-api/eb/user/delete_redis";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除报表接收人
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserDeleteReportReveiver(body, header) {
    var url = "/oauth2-api/eb/user/delete_report_reveiver";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 下载员工列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserDownloadUserInfoList(query, header) {
    var url = "/oauth2-api/eb/user/download_user_info_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据员工编号获取员工信息（含员工酒店列表）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserInfoByUserId(query, header) {
    var url = "/oauth2-api/eb/user/getUserInfoByUserId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取易企秀认证信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetEqxiuAuth(query, header) {
    var url = "/oauth2-api/eb/user/get_eqxiu_auth";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店员工(非zkt)是报表接收人的酒店列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetHotelsByUserReceiveReport(query, header) {
    var url = "/oauth2-api/eb/user/get_hotels_by_user_receive_report";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取员工的金房卡账号相关信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetJfkAccountInfo(query, header) {
    var url = "/oauth2-api/eb/user/get_jfk_account_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据当前登陆人获取商户列表
 * @param header The http request header parameters.
 */
export function getEbUserGetMerchantsByCurrentUser(header) {
    var url = "/oauth2-api/eb/user/get_merchants_by_current_user";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取三方授权（免登录）url
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetThirdAuthUrl(query, header) {
    var url = "/oauth2-api/eb/user/get_third_auth_url";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据部门id查询员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserByDepartmentId(query, header) {
    var url = "/oauth2-api/eb/user/get_user_by_department_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据角色权限查询商户员工
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserByHotelAndRoleRights(query, header) {
    var url = "/oauth2-api/eb/user/get_user_by_hotel_and_role_rights";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据手机号获取员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserByMobile(query, header) {
    var url = "/oauth2-api/eb/user/get_user_by_mobile";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据商户openId查询userId
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserInfoByShanghuOpenId(query, header) {
    var url = "/oauth2-api/eb/user/get_user_info_by_shanghu_open_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店ID获取员工信息列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserInfoListByHotelId(query, header) {
    var url = "/oauth2-api/eb/user/get_user_info_list_by_hotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店ID获取员工信息列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserInfoListByParam(query, header) {
    var url = "/oauth2-api/eb/user/get_user_info_list_by_param";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店ID获取员工信息列表
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserGetUserInfoPageListByHotelId(query, body, header) {
    var url = "/oauth2-api/eb/user/get_user_info_page_list_by_hotelId";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 根据手机号获取zkt身份员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetZktUserByMobile(query, header) {
    var url = "/oauth2-api/eb/user/get_zkt_user_by_mobile";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过excel批量导入员工信息(文件路径)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postEbUserImportUserInfoByExcel(body, header) {
    var url = "/oauth2-api/eb/user/import_user_info_by_excel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 退出接口,删除token
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserLogout(body, header) {
    var url = "/oauth2-api/eb/user/logout";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 分页获取酒店员工基本信息，查询条件：酒店id列表（必须）、部门id列表、员工id列表、部门名称（like）、员工名称(like)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserPageGetUserHotelInfos(body, header) {
    var url = "/oauth2-api/eb/user/page_get_user_hotel_infos";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取zkt员工相关信息
 * @param header The http request header parameters.
 */
export function getEbUserQueryZktUserInfo(header) {
    var url = "/oauth2-api/eb/user/query_zkt_user_info";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 重置密码
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserResetPassword(body, header) {
    var url = "/oauth2-api/eb/user/reset_password";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 搜索员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserSelectUserListByParam(query, header) {
    var url = "/oauth2-api/eb/user/select_user_list_by_param";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 设置团建账户，0627迭代团建账户下沉到部门纬度，该逻辑不再使用，请使用merchant-api中的方法
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postEbUserSetIsSecondBonusOwner(body, header) {
    var url = "/oauth2-api/eb/user/set_is_second_bonus_owner";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置员工营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserSetLastCounter(body, header) {
    var url = "/oauth2-api/eb/user/set_last_counter";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置报表接收人
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserSetReportReveiver(body, header) {
    var url = "/oauth2-api/eb/user/set_report_reveiver";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改用户配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserUpdateUserConfig(body, header) {
    var url = "/oauth2-api/eb/user/update_user_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据酒店id集合获取员工id
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserUserIdsByHotelList(body, header) {
    var url = "/oauth2-api/eb/user/user_ids_by_hotel_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据accessToken获取用户信息（含酒店权限）不再提供服务，因数据量大会造成redis存储失败，有风险
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserUserInfo(query, header) {
    var url = "/oauth2-api/eb/user/user_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据accessToken获取用户信息（含酒店权限）
 * @param header The http request header parameters.
 */
export function getEbUserUserInfoByAuthentication(header) {
    var url = "/oauth2-api/eb/user/user_info_by_authentication";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据accessToken获取用户信息（含默认商户及权限）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserUserInfoByMerchant(query, header) {
    var url = "/oauth2-api/eb/user/user_info_by_merchant";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据accessToken获取用户信息（含默认商户及权限）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserUserInfoDefaultMerchant(query, header) {
    var url = "/oauth2-api/eb/user/user_info_default_merchant";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据accessToken获取用户信息（含酒店列表）
 * @param header The http request header parameters.
 */
export function getEbUserUserInfoHotels(header) {
    var url = "/oauth2-api/eb/user/user_info_hotels";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据员工编号集合获取员工集合（含员工酒店列表）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserUserListByIds(body, header) {
    var url = "/oauth2-api/eb/user/user_list_by_ids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量获取员工信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserUserListByUserIds(body, header) {
    var url = "/oauth2-api/eb/user/user_list_by_user_ids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 员工解绑微信
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserUserRemoveBindWx(query, header) {
    var url = "/oauth2-api/eb/user/user_remove_bind_wx";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 测试报表接收
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserValidReportReveiver(query, header) {
    var url = "/oauth2-api/eb/user/valid_report_reveiver";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取用户提词
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserAiGetUserPrompt(query, header) {
    var url = "/oauth2-api/eb/user_ai/get_user_prompt";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存开通用户权限
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserAiSaveUserOauth(body, header) {
    var url = "/oauth2-api/eb/user_ai/save_user_oauth";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取用户提词
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserAiSaveUserPrompt(query, body, header) {
    var url = "/oauth2-api/eb/user_ai/save_user_prompt";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 验证用户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserAiVerifyUser(query, header) {
    var url = "/oauth2-api/eb/user_ai/verify_user";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 身份证认证
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postIdCardAuth(body, header) {
    var url = "/oauth2-api/id_card/auth";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 记录员工认证日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postIdCardAuthLog(body, header) {
    var url = "/oauth2-api/id_card/auth_log";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取身份证认证信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getIdCardGetIdcardAuthInfo(query, header) {
    var url = "/oauth2-api/id_card/get_idcard_auth_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存员工认证信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postIdCardSaveAuthInfo(body, header) {
    var url = "/oauth2-api/id_card/save_auth_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 清理已过期的eb_token
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getJobClearExpireTokens(query, header) {
    var url = "/oauth2-api/job/clear_expire_tokens";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量设置酒店菜单
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMenuBatchSetMenusHotel(body, header) {
    var url = "/oauth2-api/menu/batch_set_menus_hotel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量更新系统菜单菜单
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMenuBatchUpdateSysMenus(body, header) {
    var url = "/oauth2-api/menu/batch_update_sys_menus";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * pos机h5开关配置
 * @param header The http request header parameters.
 */
export function getMerchantAppH5Config(header) {
    var url = "/oauth2-api/merchant/app_h5_config";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取酒店密码匹配规则
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMerchantGetHotelPasswordContentRegex(query, header) {
    var url = "/oauth2-api/merchant/get_hotel_password_content_regex";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店员工账号安全配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMerchantGetHotelUserAccountSecurityConfigByHotelId(query, header) {
    var url = "/oauth2-api/merchant/get_hotel_user_account_security_config_by_hotel_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店员工账号安全配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMerchantGetHotelUserAccountSecurityConfigByMobile(query, header) {
    var url = "/oauth2-api/merchant/get_hotel_user_account_security_config_by_mobile";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店员工账号安全配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMerchantGetHotelUserAccountSecurityConfigByUserId(query, header) {
    var url = "/oauth2-api/merchant/get_hotel_user_account_security_config_by_user_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户安全配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMerchantGetMerchantSecurityConfig(query, header) {
    var url = "/oauth2-api/merchant/get_merchant_security_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取C端商户安全配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMerchantGetMerchantSecurityConfigByAppId(query, header) {
    var url = "/oauth2-api/merchant/get_merchant_security_config_by_app_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据accessToken获取用户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMerchantMerchantInfoByAccessToken(query, header) {
    var url = "/oauth2-api/merchant/merchant_info_by_accessToken";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取人员列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisAdminAdminUserList(body, header) {
    var url = "/oauth2-api/mis/admin/admin_user_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * deleteAdminUser
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisAdminDeleteUser(query, header) {
    var url = "/oauth2-api/mis/admin/delete_user";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getAdminIdByAdminName
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisAdminGetAdminIdByAdminName(query, header) {
    var url = "/oauth2-api/mis/admin/get_admin_id_by_admin_name";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取人员详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postMisAdminGetAdminUserDetail(query, header) {
    var url = "/oauth2-api/mis/admin/get_admin_user_detail";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 获取城市列表
 * @param header The http request header parameters.
 */
export function getMisAdminGetCityList(header) {
    var url = "/oauth2-api/mis/admin/get_city_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取业务部列表
 * @param header The http request header parameters.
 */
export function getMisAdminGetOfficeDepartment(header) {
    var url = "/oauth2-api/mis/admin/get_office_department";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取获取工作角色
 * @param header The http request header parameters.
 */
export function getMisAdminGetRoleList(header) {
    var url = "/oauth2-api/mis/admin/get_role_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 保存人员
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisAdminSaveAdminUser(body, header) {
    var url = "/oauth2-api/mis/admin/save_admin_user";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存人员(返回id)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisAdminSaveAdminUserReturnId(body, header) {
    var url = "/oauth2-api/mis/admin/save_admin_user_return_id";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取身份认证记录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisIdCardAuthLog(body, header) {
    var url = "/oauth2-api/mis/id_card/auth_log";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据账号密码直接进行登录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisLoginPassword(body, header) {
    var url = "/oauth2-api/mis/login/password";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据账号密码code登录,已经被废弃了，因为mis登录不需要进行验证码验证，通过vpn进行安全控制
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postMisLoginWithCode(body, header) {
    var url = "/oauth2-api/mis/login/with_code";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据账号密码获取code,已经被废弃了，因为mis登录不需要进行验证码验证，通过vpn进行安全控制
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postMisLoginWithPassword(body, header) {
    var url = "/oauth2-api/mis/login/with_password";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 全量退出登录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisManagerAllLogout(body, header) {
    var url = "/oauth2-api/mis/manager/all_logout";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取所有eb可配置的权限列表树
 * @param header The http request header parameters.
 */
export function getMisManagerEbPermissionTree(header) {
    var url = "/oauth2-api/mis/manager/eb_permission_tree";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取所有mis可配置的权限列表树
 * @param header The http request header parameters.
 */
export function getMisManagerMisPermissionTree(header) {
    var url = "/oauth2-api/mis/manager/mis_permission_tree";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取子菜单列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuGetChildMenus(query, header) {
    var url = "/oauth2-api/mis/menu/get_child_menus";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取菜单和权限树形结构
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuGetMenuTrees(query, header) {
    var url = "/oauth2-api/mis/menu/get_menu_trees";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取指定类型的菜单列表集合
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisMenuGetMenus(body, header) {
    var url = "/oauth2-api/mis/menu/get_menus";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据登录人获取菜单列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuGetMenusByAdmin(query, header) {
    var url = "/oauth2-api/mis/menu/get_menus_by_admin";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取菜单额外配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuGetMenusExtInfo(query, header) {
    var url = "/oauth2-api/mis/menu/get_menus_ext_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店菜单列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuGetMenusHotel(query, header) {
    var url = "/oauth2-api/mis/menu/get_menus_hotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有路由及权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuGetRoutePermissions(query, header) {
    var url = "/oauth2-api/mis/menu/get_route_permissions";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量导入menus数据
 * @param header The http request header parameters.
 */
export function postMisMenuManagementBatchImportMenus(header) {
    var url = "/oauth2-api/mis/menu/management/batch_import_menus";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 变更菜单排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisMenuManagementChangeMenuSort(body, header) {
    var url = "/oauth2-api/mis/menu/management/change_menu_sort";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 创建菜单
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisMenuManagementCreateMenu(body, header) {
    var url = "/oauth2-api/mis/menu/management/create_menu";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除菜单（不强制删除）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postMisMenuManagementDeleteMenuPost(query, header) {
    var url = "/oauth2-api/mis/menu/management/delete_menu_post";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 获取子菜单列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuManagementGetChildMenus(query, header) {
    var url = "/oauth2-api/mis/menu/management/get_child_menus";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据id获取菜单信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuManagementGetMenuInfo(query, header) {
    var url = "/oauth2-api/mis/menu/management/get_menu_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取菜单树形结构
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisMenuManagementGetMenuTrees(query, header) {
    var url = "/oauth2-api/mis/menu/management/get_menu_trees";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有模块代码
 * @param header The http request header parameters.
 */
export function getMisMenuManagementGetModuleCodes(header) {
    var url = "/oauth2-api/mis/menu/management/get_module_codes";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 修改菜单
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisMenuManagementUpdateMenu(body, header) {
    var url = "/oauth2-api/mis/menu/management/update_menu";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存菜单额外配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisMenuSaveMenusExtInfo(body, header) {
    var url = "/oauth2-api/mis/menu/save_menus_ext_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置酒店菜单
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisMenuSaveMenusHotel(body, header) {
    var url = "/oauth2-api/mis/menu/save_menus_hotel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除商户授权配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisOauthDelMerchantOauthConfig(query, header) {
    var url = "/oauth2-api/mis/oauth/del_merchant_oauth_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户授权配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisOauthGetMerchantOauthConfig(query, header) {
    var url = "/oauth2-api/mis/oauth/get_merchant_oauth_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * EB商户是否授权完成
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisOauthMerchantHasOauthComplete(query, header) {
    var url = "/oauth2-api/mis/oauth/merchant_has_oauth_complete";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存商户授权配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisOauthSaveMerchantOauthConfig(body, header) {
    var url = "/oauth2-api/mis/oauth/save_merchant_oauth_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * deleteSysOffice
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisOrganizationDeleteSysOffice(query, header) {
    var url = "/oauth2-api/mis/organization/delete_sys_office";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getAdminList
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function getMisOrganizationGetAdminList(query, header) {
    var url = "/oauth2-api/mis/organization/get_admin_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取指定组织架构的子层级
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisOrganizationGetSecondeSysOfficeById(query, header) {
    var url = "/oauth2-api/mis/organization/get_seconde_sys_office_by_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取大区/办事处TL奖金配置信息
 * @param header The http request header parameters.
 */
export function getMisOrganizationGetSysOfficeBonusConfig(header) {
    var url = "/oauth2-api/mis/organization/get_sys_office_bonus_config";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * getSysOfficeByIdList
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisOrganizationGetSysOfficeByIdList(body, header) {
    var url = "/oauth2-api/mis/organization/get_sys_office_by_id_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * getSysOfficeList
 * @param header The http request header parameters.
 */
export function getMisOrganizationGetSysOfficeList(header) {
    var url = "/oauth2-api/mis/organization/get_sys_office_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取办事处和大区负责人id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisOrganizationGetSysOfficeManagerId(query, header) {
    var url = "/oauth2-api/mis/organization/get_sys_office_manager_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getSysOfficeListNoTree
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisOrganizationGetSysOfficeNoTree(query, header) {
    var url = "/oauth2-api/mis/organization/get_sys_office_no_tree";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * moveSysOffice
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisOrganizationMoveSysOffice(body, header) {
    var url = "/oauth2-api/mis/organization/move_sys_office";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * saveSysOffice
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisOrganizationSaveSysOffice(body, header) {
    var url = "/oauth2-api/mis/organization/save_sys_office";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存大区/办事处TL奖金配置信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisOrganizationSaveSysOfficeBonusConfig(body, header) {
    var url = "/oauth2-api/mis/organization/save_sys_office_bonus_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据Id删除角色
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisRoleDeleteRole(query, header) {
    var url = "/oauth2-api/mis/role/delete_role";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据Id删除角色模板
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisRoleDeleteTemplateRole(query, header) {
    var url = "/oauth2-api/mis/role/delete_template_role";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据accessToken获取用户数据权限
 * @param header The http request header parameters.
 */
export function getMisRoleGetCurrentUserDataScope(header) {
    var url = "/oauth2-api/mis/role/get_current_user_data_scope";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据指定员工id获取数据范围
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisRoleGetDataScopeByRole(query, header) {
    var url = "/oauth2-api/mis/role/get_data_scope_by_role";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取品牌和业主列表(用于数据权限)
 * @param header The http request header parameters.
 */
export function getMisRoleGetHotelBrandProprietors(header) {
    var url = "/oauth2-api/mis/role/get_hotel_brand_proprietors";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据角色编号获取商户角色信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisRoleGetRoleInfo(query, header) {
    var url = "/oauth2-api/mis/role/get_role_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户角色列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisRoleGetRoleList(query, header) {
    var url = "/oauth2-api/mis/role/get_role_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据角色模板id获取角色模板信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisRoleGetTemplateRoleInfo(query, header) {
    var url = "/oauth2-api/mis/role/get_template_role_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取角色模板列表
 * @param header The http request header parameters.
 */
export function getMisRoleGetTemplateRoleList(header) {
    var url = "/oauth2-api/mis/role/get_template_role_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据adminId获取员工数据权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisRoleGetUserDataScopeByAdminId(query, header) {
    var url = "/oauth2-api/mis/role/get_user_data_scope_by_admin_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存员工角色信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisRoleSaveAdminRole(body, header) {
    var url = "/oauth2-api/mis/role/save_admin_role";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存角色数据权限
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisRoleSaveDataScope(body, header) {
    var url = "/oauth2-api/mis/role/save_data_scope";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存角色
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisRoleSaveRole(body, header) {
    var url = "/oauth2-api/mis/role/save_role";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存角色模板
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisRoleSaveTemplateRole(body, header) {
    var url = "/oauth2-api/mis/role/save_template_role";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 同步rights到role
 * @param header The http request header parameters.
 */
export function getMisRoleSyncRightsToRole(header) {
    var url = "/oauth2-api/mis/role/sync_rights_to_role";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 员工离职
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserAdminDimission(body, header) {
    var url = "/oauth2-api/mis/user/admin_dimission";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取员工入离职记录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserAdminDimissionRecords(body, header) {
    var url = "/oauth2-api/mis/user/admin_dimission_records";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过userIds批量获取admin信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserBatchQueryAdminInfoByUserIds(body, header) {
    var url = "/oauth2-api/mis/user/batch_query_admin_info_by_user_ids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据Mis accessToken获取Eb令牌,后端使用
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postMisUserBgCreateEbtokenByMistoken(query, header) {
    var url = "/oauth2-api/mis/user/bg_create_ebtoken_by_mistoken";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 根据Mis accessToken获取Eb令牌
 * @param header The http request header parameters.
 */
export function postMisUserCreateEbtokenByMistoken(header) {
    var url = "/oauth2-api/mis/user/create_ebtoken_by_mistoken";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 企业微信通过code获取令牌
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postMisUserCreateTokenByCode(query, header) {
    var url = "/oauth2-api/mis/user/create_token_by_code";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 通过邮箱获取zkt员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisUserGetAdminInfoByEmail(query, header) {
    var url = "/oauth2-api/mis/user/get_admin_info_by_email";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取zkt员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisUserGetAdminList(query, header) {
    var url = "/oauth2-api/mis/user/get_admin_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过用户名获取管理员信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserGetAdminUserByAdminId(body, header) {
    var url = "/oauth2-api/mis/user/get_admin_user_by_admin_id";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取当前登录人用户信息权限
 * @param header The http request header parameters.
 */
export function getMisUserGetCurrentUserInfo(header) {
    var url = "/oauth2-api/mis/user/get_current_user_info";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取部门类别
 * @param header The http request header parameters.
 */
export function getMisUserGetDepartmentCategory(header) {
    var url = "/oauth2-api/mis/user/get_department_category";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取酒店部门列表(分页)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisUserGetHotelDepartments(query, header) {
    var url = "/oauth2-api/mis/user/get_hotel_departments";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取技术平台用户权限
 * @param header The http request header parameters.
 */
export function getMisUserGetTechAdminPermissions(header) {
    var url = "/oauth2-api/mis/user/get_tech_admin_permissions";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据酒店ID获取员工信息列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisUserGetUserHotelInfoList(query, header) {
    var url = "/oauth2-api/mis/user/get_user_hotel_info_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取当前登录人所有数据权限下员工列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisUserGetUsersByLoginUserId(query, header) {
    var url = "/oauth2-api/mis/user/get_users_by_login_user_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存员工标准化部门分类（数据统计专用）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserSaveUserDepartmentCategory(body, header) {
    var url = "/oauth2-api/mis/user/save_user_department_category";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改权限
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserUpdateUserPermission(body, header) {
    var url = "/oauth2-api/mis/user/update_user_permission";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据accessToken获取用户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisUserUserInfoByAccesstoken(query, header) {
    var url = "/oauth2-api/mis/user/user_info_by_accesstoken";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据组织架构编号获取员工列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisUserUserInfoByOffice(query, header) {
    var url = "/oauth2-api/mis/user/user_info_by_office";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 退出接口,删除token，管理员用户修改密码后全端退出
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postOauthAdminChangePasswordAllLogout(query, header) {
    var url = "/oauth2-api/oauth/admin_change_password/all_logout";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 检查accessToken 是否有效
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getOauthCheckAccessToken(query, header) {
    var url = "/oauth2-api/oauth/check_access_token";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据access_token获取指定客户端信息
 * @param header The http request header parameters.
 */
export function getOauthClientInfo(header) {
    var url = "/oauth2-api/oauth/client_info";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 接口权限校验根据accessToken(Eb)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getOauthEbInterfaceCanDoByAccesstoken(query, header) {
    var url = "/oauth2-api/oauth/eb/interface_can_do_by_accesstoken";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * userPermissions
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getOauthEbPermissionUserPermissions(query, header) {
    var url = "/oauth2-api/oauth/eb/permission/user_permissions";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据Header accessToken获取EB用户信息
 * @param header The http request header parameters.
 */
export function getOauthEbUserUserInfo(header) {
    var url = "/oauth2-api/oauth/eb/user/user_info";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据accessToken获取用户信息（含默认商户及权限）
 * @param header The http request header parameters.
 */
export function getOauthEbUserUserInfoDefaultMerchant(header) {
    var url = "/oauth2-api/oauth/eb/user/user_info_default_merchant";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 校验集团共享关系
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getOauthEbValidBrandHotelRelation(query, header) {
    var url = "/oauth2-api/oauth/eb/valid_brand_hotel_relation";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据accessToken获取用户信息mis 或eb
 * @param header The http request header parameters.
 */
export function getOauthGetCurrentUserInfo(header) {
    var url = "/oauth2-api/oauth/get_current_user_info";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 接口权限校验根据老的组合token(Eb)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getOauthInterfaceCanDo(query, header) {
    var url = "/oauth2-api/oauth/interface_can_do";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据openId创建token(用于授权与获取openId信息分开场景)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOauthLoginCreateZktToken(body, header) {
    var url = "/oauth2-api/oauth/login/create_zkt_token";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取特殊酒店认证配置信息
 * @param header The http request header parameters.
 */
export function getOauthLoginGetSpecialAuthConfigCode(header) {
    var url = "/oauth2-api/oauth/login/get_special_auth_config_code";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 静默登录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOauthLoginSilentLogin(body, header) {
    var url = "/oauth2-api/oauth/login/silent_login";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 三方登录获取openId接口(用于授权与获取openId信息分开场景)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOauthLoginThirdLogin(body, header) {
    var url = "/oauth2-api/oauth/login/third_login";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 三方登录并授权token
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOauthLoginThirdLoginToken(body, header) {
    var url = "/oauth2-api/oauth/login/third_login_token";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取登录白名单列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOauthLoginWhiteIpGetLoginWhiteIpList(body, header) {
    var url = "/oauth2-api/oauth/login_white_ip/get_login_white_ip_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 退出接口,删除token，用户修改密码后全端退出
 * @param header The http request header parameters.
 */
export function postOauthUserAllLogout(header) {
    var url = "/oauth2-api/oauth/user/all_logout";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 退出接口,删除token
 * @param header The http request header parameters.
 */
export function postOauthUserLogout(header) {
    var url = "/oauth2-api/oauth/user/logout";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 三方SSO登录成功回调
 * @param header The http request header parameters.
 */
export function getOauth2SsoLoginConsumer(header) {
    var url = "/oauth2-api/oauth2/sso_login_consumer";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 生成授权码
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOauthCodeGeneratorAuthCode(body, header) {
    var url = "/oauth2-api/oauth_code/generator_auth_code";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过authCode获取用户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getOauthCodeGetMemberDetalByAuthCode(query, header) {
    var url = "/oauth2-api/oauth_code/get_member_detal_by_auth_code";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据code获取access_token
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicOauthGetAccessTokenByCode(query, header) {
    var url = "/oauth2-api/public/oauth/getAccessTokenByCode";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据access_token获取句子用户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicOauthGetJuziUserByToken(query, header) {
    var url = "/oauth2-api/public/oauth/getJuziUserByToken";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 客户端生成token
 * @param header The http request header parameters.
 */
export function postPublicOauthGetTokenByClientCredentials(header) {
    var url = "/oauth2-api/public/oauth/get_token_by_client_credentials";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 绑定手机号
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postPublicZktwxaBindMobile(body, header) {
    var url = "/oauth2-api/public/zktwxa/bind_mobile";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据code登录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postPublicZktwxaLoginWithCode(body, header) {
    var url = "/oauth2-api/public/zktwxa/login_with_code";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据code三方登录
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSamlThirdPartyLogin(query, header) {
    var url = "/oauth2-api/saml/third_party_login";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 三方登录成功回调
 * @param header The http request header parameters.
 */
export function postSamlThirdPartyLoginConsumer(header) {
    var url = "/oauth2-api/saml/third_party_login_consumer";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 三方登录成功回调
 * @param header The http request header parameters.
 */
export function postSamlThirdPartyLogoutConsumer(header) {
    var url = "/oauth2-api/saml/third_party_logout_consumer";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * url签名
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSignSignUrl(body, header) {
    var url = "/oauth2-api/sign/sign_url";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * url验签
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSignVerifySignedUrl(body, header) {
    var url = "/oauth2-api/sign/verify_signed_url";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 添加系统操作日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSysLogAddSysOperateLog(body, header) {
    var url = "/oauth2-api/sys_log/add_sys_operate_log";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * redisP
 * @param header The http request header parameters.
 */
export function getTestRedisP(header) {
    var url = "/oauth2-api/test/redis_p";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 批量检查手机号是否是酒店注册员工
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBatchCheckUserHotelByMobile(body, header) {
    var url = "/oauth2-api/user/batch_check_user_hotel_by_mobile";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量修改权限
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBatchUpdateUserPermission(body, header) {
    var url = "/oauth2-api/user/batch_update_user_permission";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 校验用户角色
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserCheckAdminHasRole(query, header) {
    var url = "/oauth2-api/user/checkAdminHasRole";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 检查手机号是否是酒店注册员工
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserCheckUserHotelByMobile(query, header) {
    var url = "/oauth2-api/user/check_user_hotel_by_mobile";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 判断hotelId、userId、departmentId是否存在记录
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserExistUserHotelDepartment(query, header) {
    var url = "/oauth2-api/user/exist_user_hotel_department";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取mis员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetAdminInfoById(query, header) {
    var url = "/oauth2-api/user/get_admin_info_by_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有酒店团建账户
 * @param header The http request header parameters.
 */
export function getUserGetAllSecondBonusOwner(header) {
    var url = "/oauth2-api/user/get_all_second_bonus_owner";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取易企秀企业token
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetEqxiuToken(query, header) {
    var url = "/oauth2-api/user/get_eqxiu_token";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据员工ID、酒店ID搜索员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetInfoByUserAndHotel(query, header) {
    var url = "/oauth2-api/user/get_info_by_user_and_hotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询管理员的权限下的办事处
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetOfficeDepartmentList(query, header) {
    var url = "/oauth2-api/user/get_office_department_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取推荐人酒店信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetRecommendUserHotelInfo(query, header) {
    var url = "/oauth2-api/user/get_recommend_user_hotel_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取员工所关联酒店下的员工id集合
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetRelateUsersByUser(query, header) {
    var url = "/oauth2-api/user/get_relate_users_by_user";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过酒店id查询酒店团建账户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetSecondBonusOwner(query, header) {
    var url = "/oauth2-api/user/get_second_bonus_owner";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过商户版openId查询首绑酒店信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetShanghuFirstBindHotelInfo(query, header) {
    var url = "/oauth2-api/user/get_shanghu_first_bind_hotel_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户版平台授权信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetShanghuPlatformOauthInfo(query, header) {
    var url = "/oauth2-api/user/get_shanghu_platform_oauth_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据员工好姓名搜索员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserIdByUserName(query, header) {
    var url = "/oauth2-api/user/get_user_id_by_user_name";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取员工身份证认证信息（不推荐使用，不兼容老数据）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetUserIdcardAuthInfo(body, header) {
    var url = "/oauth2-api/user/get_user_idcard_auth_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据身份证hash获取员工身份证认证信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserIdcardAuthInfoByIdhash(query, header) {
    var url = "/oauth2-api/user/get_user_idcard_auth_info_by_idhash";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取员工身份证认证信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetUserIdcardStatusInfo(body, header) {
    var url = "/oauth2-api/user/get_user_idcard_status_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取用户身份信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserIdentityInfo(query, header) {
    var url = "/oauth2-api/user/get_user_identity_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据员工姓名查询userIds
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserIdsByName(query, header) {
    var url = "/oauth2-api/user/get_user_ids_by_name";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量获取酒店员工信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetUserInfoListByUserIds(body, header) {
    var url = "/oauth2-api/user/get_user_info_list_by_user_ids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取员工工作状态信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserWorkStatus(query, header) {
    var url = "/oauth2-api/user/get_user_work_status";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量获取酒店员工商户版信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetWechatAccountByUserids(body, header) {
    var url = "/oauth2-api/user/get_wechat_account_by_userids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 判断指定员工在指定酒店是否存在指定操作权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserIsHasPermission(query, header) {
    var url = "/oauth2-api/user/is_has_permission";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 登录校验验证码
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserLoginValidCaptcha(body, header) {
    var url = "/oauth2-api/user/login_valid_captcha";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存商户版平台授权信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserSaveShanghuPlatformOauthInfo(body, header) {
    var url = "/oauth2-api/user/save_shanghu_platform_oauth_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置员工工作状态信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserSetUserWorkStatus(body, header) {
    var url = "/oauth2-api/user/set_user_work_status";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更新员工与营业点关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUpdateUserCounterRelation(body, header) {
    var url = "/oauth2-api/user/update_user_counter_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取员工所有酒店关系信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUserHotelRelationInfos(body, header) {
    var url = "/oauth2-api/user/user_hotel_relation_infos";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据部门和营业点筛选员工信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUserInfoByDepartmentCounter(body, header) {
    var url = "/oauth2-api/user/user_info_by_department_counter";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量获取员工信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUserListByUserIds(body, header) {
    var url = "/oauth2-api/user/user_list_by_user_ids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 员工登录是否需要验证码
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserUserLoginNeedCaptcha(query, header) {
    var url = "/oauth2-api/user/user_login_need_captcha";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量获取员工工作状态信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUserWorkStatusInfos(body, header) {
    var url = "/oauth2-api/user/user_work_status_infos";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过userId和adminId检查是否是同一人
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserVerifySamePerson(query, header) {
    var url = "/oauth2-api/user/verify_same_person";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据accessToken获取用户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getZktwxaGetUserInfoByAccesstoken(query, header) {
    var url = "/oauth2-api/zktwxa/get_user_info_by_accesstoken";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 数据小程序解绑
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postZktwxaUnbindWxaData(body, header) {
    var url = "/oauth2-api/zktwxa/unbind_wxa_data";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
//#endregion
